export const nl_BE = {
    LEFT: 'Links: Verplaats naar de vorige dag.',
    RIGHT: 'Rechts: Verplaatst naar de volgende dag.',
    DOWN: 'Omlaag: Verplaats naar de volgende rij.',
    UP: 'Boven: Verplaats naar de vorige rij.',
    PGUP: 'PgUp: ga naar de vorige maand.',
    PGDOWN: 'PgDown: ga naar de volgende maand.',
    HOME: 'Home: naar het vorige jaar.',
    END: 'Einde: naar het volgende jaar.',
    ESC: 'Esc/Vandaag/Sluiten: sluit de agenda.',
    TITLE: 'Toetsenbord Instructies'
};
